export const colors = [
  '#374763',
  '#6F4473',
  '#abb4d1',
  '#937396',
  '#d3dfe3',
  '#508090',
  '#B7A1B9',
  '#2b2d36',
  '#638e92',
  '#396caa',
]

export const formatYears = (value: string | number): string => {
  return `'${value.toString().slice(-2)}`
}

export type BarGraphData = {
  id: string
  data: {
    x: any
    y: any
  }[]
}
